import { render } from "./cert-type-select.vue?vue&type=template&id=0588e242&scoped=true"
import script from "./cert-type-select.vue?vue&type=script&lang=js"
export * from "./cert-type-select.vue?vue&type=script&lang=js"

import "./cert-type-select.vue?vue&type=style&index=0&id=0588e242&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0588e242"]])

export default __exports__